import React, {useState} from 'react';
import {Input} from '@mantine/core';
import {useField} from 'formik';

function MantineInputField(props) {
    const {label, name} = props;
    const [field, meta, helpers] = useField(name);
    const [value, setValue] = useState(field.value);
    const {setValue: setFieldValue, setTouched} = helpers;

    return (
        <Input.Wrapper
            {...props}
            id={`wrapper-${name}`}
            label={label}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
        >
            <Input id={name}
                   {...props}
                   value={value}
                   onBlur={(e) => {
                       setFieldValue(e.target.value)
                       setTouched(name, false)
                   }}
                   onChange={(e) => setValue(e.target.value)}/>
        </Input.Wrapper>
    );
}

export default MantineInputField;